import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from '@nosto/preact'
import {
    productImagePlaceholder,
    getSrcset,
    handleQuickView,
    handleSwatchSelect,
    fetchShopifyData,
} from '../helpers'
import { useEffect, useRef, useState, useMemo } from 'preact/hooks'

export default function Product({ product, swatchData }) {
    const { format } = useCurrencyFormatting()
    const [selectedSwatch, setSelectedSwatch] = useState(product)
    const [productData, setProductData] = useState(null)
    const [imageSwatchUrl, setImageSwatchUrl] = useState('')
    var swatchField = useMemo(() => product.customFields?.find((field) => field.key === 'product-swatch_images')?.value, [])
    const colorSet = new Set();
    var skuArr = []
    let variantArr = []
    selectedSwatch: selectedSwatch.imageUrl
    const nostoHandleUrl = selectedSwatch?.url ? selectedSwatch?.url.split('/').pop() : `${(product.url).split('/').pop()}?variant=${selectedSwatch.id}`
    const tag = selectedSwatch.tags1?.find((tag) => tag.startsWith('tag:'))
    const currentId = swatchField ? product.productId : selectedSwatch.productId
    const tagValue = tag?.replace('tag:', '');
    const swatchTag = useMemo(
        () => product.customFields?.find((field) => field.key === 'custom-color_swatch_group')?.value,
        []
    )
    const swatchProducts = useMemo(
        () => (swatchTag ? swatchData.find((data) => data.groupId === swatchTag)?.products : false),
        [swatchTag, swatchData]
    )


    if(swatchField){
        swatchField = JSON.parse(swatchField)
        product?.skus?.forEach(sku => {
            var color = sku.customFields?.find(field => field.key == "color")?.value;
            if (!colorSet.has(color)) {
                colorSet.add(color);
                skuArr = [...skuArr, sku];
            }
        })
    }
    
    
    function handleSwatchSelect(e, prod) {
        e.preventDefault();
        e.stopImmediatePropagation();
        setSelectedSwatch(prod)
    }

    async function loadShopifyData() {
        const filteredCustomFields = []
        if (swatchProducts) {
            swatchProducts.map((prod) => {
                const imageSwatchPath = prod?.attributes?.find(
                    (field) => field.key === 'custom-color_swatch_print'
                )?.value
                if (imageSwatchPath) {
                    filteredCustomFields.push(imageSwatchPath)
                }
            })
        } else {
            const imageSwatchPath = product?.customFields?.find(
                (field) => field.key === 'custom-color_swatch_print'
            )?.value
            if (imageSwatchPath) {
                filteredCustomFields.push(imageSwatchPath)
            }
        }
       
        const fetchedData = await fetchShopifyData(filteredCustomFields)
        setProductData(fetchedData)
    }

    useEffect(() => {
        loadShopifyData()
    }, [swatchProducts])

    return (
        <SerpElement
            as="a"
            hit={swatchField ? product : selectedSwatch}
            class="ns-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit nosto-product-info"
            x-nosto-handle={nostoHandleUrl}
        >
            <div class="ns-product-item ProductItem" data-tags1={selectedSwatch.tags1}>
                <div class="ns-product-item-wrapper ns-relative">
                    <div class="ns-aspect-ratio-img">
                        <img
                            class="ns-ProductItem__Image ns-ProductItem__Image--alternate ns-Image--fadeIn lazyautosizes"
                            data-sizes="auto"
                            alt={selectedSwatch.name}
                            loading="lazy"
                            src={selectedSwatch?.alternateImageUrls?.[0] || selectedSwatch?.imageUrl}
                        />
                        <img
                            class="ns-ProductItem__Image ns-Image--fadeIn lazyautosizes"
                            data-sizes="auto"
                            alt={selectedSwatch.name}
                            loading="lazy"
                            data-srcset={getSrcset(selectedSwatch.imageUrl ?? productImagePlaceholder)}
                            sizes="422px"
                            srcset={getSrcset(selectedSwatch.imageUrl ?? productImagePlaceholder)}
                        />

                        {product?.skus.length > 1 ? (
                            <>
                                <button
                                    type="button"
                                    aria-controls={`product-quick-buy-template--16145886019672__main---${currentId}`}
                                    class="product-card__quick-add-button">
                                    <span class="sr-only">Choose options</span>
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        fill="none"
                                        width="12"
                                        class="icon icon-plus"
                                        viewBox="0 0 12 12"
                                    >
                                        <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1"></path>
                                    </svg>
                                </button>

                                <quick-buy-modal
                                    handle={nostoHandleUrl}
                                    class="quick-buy-modal modal"
                                    id={`product-quick-buy-template--16145886019672__main---${currentId}`}
                                    role="dialog"
                                    aria-modal="true"
                                ></quick-buy-modal>
                            </>
                        ) : (
                            <form
                                method="post"
                                action="/cart/add"
                                id={`product_form_${currentId}`}
                                accept-charset="UTF-8"
                                class="shopify-product-form"
                                enctype="multipart/form-data"
                                is="product-form">
                                <input type="hidden" name="form_type" value="product" />
                                <input type="hidden" name="utf8" value="✓" />
                                <input type="hidden" name="id" value={selectedSwatch?.skus[0]?.id} />
                                <button type="submit" class="product-card__quick-add-button">
                                    <span class="sr-only">Add to Bag</span>
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        fill="none"
                                        width="12"
                                        class="icon icon-plus"
                                        viewBox="0 0 12 12">
                                        <path
                                            d="M6 0v12M0 6h12"
                                            stroke="currentColor"
                                            stroke-width="1"></path>
                                    </svg>
                                </button>
                            </form>
                        )}
                    </div>
                    {tagValue && selectedSwatch?.availability === 'InStock' && (
                        <span class={`ns-Product__Tag Product__Tag--${tagValue.replace(' ', '')}`}>{tagValue}</span>
                    )}
                    {selectedSwatch?.availability != 'InStock' && (
                        <div class="ProductItem__LabelList">
                            <span class="ProductItem__Label ProductItem__Label--soldOut Heading Text--subdued">
                                Sold Out
                            </span>
                        </div>
                    )}
                    <div class="ns-product-item-info" data-nosto-element="product">
                        <div class="ns-product-title ns-clipped ns-text-four-lines ns-text-md-three-lines x-nosto-title">
                            { swatchField ?
                                 <> {product.name} </> : 
                                 <> {selectedSwatch.name} </> 
                            }
                        </div>

                        {selectedSwatch.price != selectedSwatch.listPrice && selectedSwatch.listPrice ? (
                            <div class="ns-sale-container ns-d-flex ns-justify-content-center">
                                <div class="ns-product-price nosto-newprice ns-sale-price">
                                    {format(selectedSwatch.price)}
                                </div>
                                <div class="ns-product-price nosto-newprice ns-original-price">
                                    {format(selectedSwatch.listPrice)}
                                </div>
                            </div>
                        ) : (
                            <div class="ns-product-price nosto-newprice">{format(selectedSwatch.price)}</div>
                        )}
                        {swatchField && 
                            <div class="ColorSwatches__Wrapper">
                              <div class="ColorSwatches__Colors">
                                {skuArr?.map((variant) => {
                                    let color = variant.customFields?.find(field => field.key == "color")?.value;
                                    let img = swatchField?.[color]?.url;
                                    return (
                                        <a 
                                            href={product.url}
                                            class="ColorSwatches_Color"
                                            onClick={(e) => handleSwatchSelect(e, variant)}
                                            style={`background: center / cover no-repeat url(${img})`}
                                        >
                                            {color}
                                        </a>
                                    )
                                })}
                              </div>
                            </div>
                        }
                        {!swatchField && 
                            <>
                                {swatchProducts?.length > 0 ? (
                                    <div class="ColorSwatches__Wrapper">
                                        <div class="ColorSwatches__Colors">
                                            {swatchProducts.map((prod) => {
                                                const colorSwatch = prod?.attributes?.find(
                                                    (field) => field.key === 'custom-color_swatch_color'
                                                )?.value
                                                const imageSwatchPath = prod?.attributes?.find(
                                                    (field) => field.key === 'custom-color_swatch_print'
                                                )?.value
                                                let imageSwatchUrl
                                                const correspondingObject = productData
                                                    ? productData?.find(
                                                        (item) => item?.data?.node?.id === imageSwatchPath
                                                    )
                                                    : null
                                                if (correspondingObject) {
                                                    imageSwatchUrl = correspondingObject?.data?.node?.image?.url
                                                }
                                                const variantHandleUrl = prod?.url.split('/').pop()
                                                return (
                                                    <a
                                                        href={prod.url}
                                                        data-url={`/products/${variantHandleUrl}`}
                                                        alt={prod.name}
                                                        title={prod.name}
                                                        style={
                                                            colorSwatch
                                                                ? `background:${colorSwatch}`
                                                                : `background: center / cover no-repeat url(${imageSwatchUrl});`
                                                        }
                                                        class={`ColorSwatches__Color ${
                                                            selectedSwatch.productId === prod.productId
                                                                ? 'active'
                                                                : ''
                                                        }`}
                                                        onClick={(e) => handleSwatchSelect(e, prod)}>
                                                        {prod.name}
                                                    </a>
                                                )
                                            })}
                                        </div>
                                    </div>
                                ) : (
                                    <div class="ColorSwatches__Wrapper">
                                        <div class="ColorSwatches__Colors">
                                            {(() => {
                                                const colorSwatch = product?.customFields?.find(
                                                    (field) => field.key === 'custom-color_swatch_color'
                                                )?.value
                                                const imageSwatchPath = product?.customFields?.find(
                                                    (field) => field.key === 'custom-color_swatch_print'
                                                )?.value
                                                let imageSwatchUrl
                                                const correspondingObject = productData
                                                    ? productData?.find(
                                                        (item) => item?.data?.node?.id === imageSwatchPath
                                                    )
                                                    : null
                                                if (correspondingObject) {
                                                    imageSwatchUrl = correspondingObject?.data?.node?.image?.url
                                                }
                                                //console.log("product", product, "imageSwatchPath", imageSwatchPath, "correspondingObject", correspondingObject, "productData", productData)
                                                return (
                                                    <a
                                                        href={product.url}
                                                        data-url={`/products/${product?.url.split('/').pop()}`}
                                                        alt={product.name}
                                                        title={product.name}
                                                        style={
                                                            colorSwatch
                                                                ? `background:${colorSwatch}`
                                                                : `background: center / cover no-repeat url(${imageSwatchUrl});`
                                                        }
                                                        class={`ColorSwatches__Color active`}>
                                                        {product.name}
                                                    </a>
                                                )
                                            })()}
                                        </div>
                                    </div>
                                )}
                            </>
                        }
                        {/* <div class="Button Button--secondary QuickViewOpener ns-QuickViewOpener" data-product-handle={nostoHandleUrl} onClick={(e) => handleQuickView(e, nostoHandleUrl)}>QUICK ADD</div> */}
                    </div>
                </div>
            </div>
        </SerpElement>
    )
}
